module.exports = __webpack_public_path__ + "img/maintenance.97778aff.svg";